import timg1 from '../images/team/1.jpg'
import timg2 from '../images/team/2.jpg'
import timg3 from '../images/team/3.jpg'
import timg4 from '../images/team/4.jpg'
import timg5 from '../images/team/5.jpg'
import timg6 from '../images/team/6.jpg'
import timg7 from '../images/team/7.jpg'
import timg8 from '../images/team/8.jpg'
import timg9 from '../images/team/9.jpg'
import timg10 from '../images/team/10.jpg'
import timg11 from '../images/team/11.jpg'
import timg12 from '../images/team/12.jpg'




import Stime1 from '../images/team/S1.jpg'
import Stime2 from '../images/team/S2.jpg'
import Stime3 from '../images/team/S3.jpg'
import Stime4 from '../images/team/S4.jpg'
import Stime5 from '../images/team/S5.jpg'
import Stime6 from '../images/team/S6.jpg'
import Stime7 from '../images/team/S7.jpg'
import Stime8 from '../images/team/S8.jpg'
import Stime9 from '../images/team/S9.jpg'
import Stime10 from '../images/team/S10.jpg'
import Stime11 from '../images/team/S11.jpg'
import Stime12 from '../images/team/S12.jpg'



const Teams = [
    {
        id: '1',
        title: 'Henry Bannet',
        subtitle: 'Creative Director',
        slug: 'Henry-Bannet',
        timg: timg1,
        Sime: Stime1,
    },
    {
        id: '2',
        title: 'Tanean Akrasen',
        subtitle: 'HEAD OF PLANNING',
        slug: 'Tanean-Akrasen',
        timg: timg2,
        Sime: Stime2,
    },
    {
        id: '3',
        title: 'Lily Margerat',
        subtitle: 'Art Director',
        slug: 'Lily-Margerat',
        timg: timg3,
        Sime: Stime3,
    },
    {
        id: '4',
        title: 'William Watson',
        subtitle: 'Creative Director',
        slug: 'William-Watson',
        timg: timg4,
        Sime: Stime4,
    },
    {
        id: '5',
        title: 'Leslie Alexander',
        subtitle: 'GRAPHIC DESIGNER',
        slug: 'Leslie-Alexander',
        timg: timg5,
        Sime: Stime5,
    }
    ,
    {
        id: '6',
        title: 'Aleesha Brown',
        subtitle: 'Marketing Expert',
        slug: 'Aleesha-Brown',
        timg: timg6,
        Sime: Stime6,
    }
    ,
    {
        id: '7',
        title: 'James Baker',
        subtitle: 'Project Manager',
        slug: 'James-Baker',
        timg: timg7,
        Sime: Stime7,
    }
    ,
    {
        id: '8',
        title: 'Ryan Rickets',
        subtitle: 'Consulting Officer',
        slug: 'Ryan-Rickets',
        timg: timg8,
        Sime: Stime8,
    }
    ,
    {
        id: '9',
        title: 'Leslie Alexander',
        subtitle: 'creative director',
        slug: 'Leslie-Alexander',
        timg: timg9,
        Sime: Stime9,
    }
    ,
    {
        id: '10',
        title: 'Brooklyn Simmons',
        subtitle: 'CEO Founder',
        slug: 'Brooklyn-Simmons',
        timg: timg10,
        Sime: Stime10,
    }
    ,
    {
        id: '11',
        title: 'Linda Jackson',
        subtitle: 'CTO & Product Management',
        slug: 'Linda-Jackson',
        timg: timg11,
        Sime: Stime11,
    }
    ,
    {
        id: '12',
        title: 'Andrea G. Turner',
        subtitle: 'Marketing Director',
        slug: 'Andrea-Turner',
        timg: timg12,
        Sime: Stime12,
    }
]

export default Teams;



